export default function ({ $axios, $auth }) {
  $axios.interceptors.response.use((response) => {
    if (response.headers["x-zoho-disconnected"]) {
      $auth.fetchUser();
    }
    return response;
  });
}
